import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SegmentService {

  endpoint = 'tools/customer-data';

  constructor(private http: HttpClient) { }

  identify(payload): Observable<any> {
    return this.http.post<any>(`${environment.people_url}/${this.endpoint}/identify`, payload);
  }

  page(payload): Observable<any> {
    return this.http.post<any>(`${environment.people_url}/${this.endpoint}/page`, payload);
  }

  track(payload): Observable<any> {
    return this.http.post<any>(`${environment.people_url}/${this.endpoint}/track`, payload);
  }

}
